import Reveal from '@/components/base/Reveal';
import { chatHighlights, chatThread } from '@/mocks/home';

function ChatExpose() {
  return (
    <section id="chat" className="w-full bg-background-950 py-20 md:py-28">
      <div className="max-w-shell mx-auto px-4 md:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] text-accent-400 font-label">
              <i className="ri-chat-3-line"></i>
              CHAT LEAK
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-background-50">
              私聊记录曝光
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-300">
              还原关键对话的原始顺序与时间戳，敏感信息已做模糊化处理。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <Reveal className="lg:col-span-7" delay={60}>
            <div className="rounded-lg border border-background-800 bg-background-900 p-5 md:p-7">
              <div className="flex items-center justify-between pb-5 border-b border-background-800">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-background-800 flex items-center justify-center text-background-200">
                    <i className="ri-user-3-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-sm text-background-50 font-medium">匿名对话记录</p>
                    <p className="text-xs text-background-400 mt-0.5">来源：爆料人提供的截图</p>
                  </div>
                </div>
                <span className="px-2.5 py-1 rounded-md bg-primary-900/60 text-primary-200 text-xs whitespace-nowrap">
                  已核实 3 处
                </span>
              </div>

              <div className="mt-6 flex flex-col gap-5">
                {chatThread.map((message, index) => {
                  const isMe = message.side === 'me';
                  return (
                    <div
                      key={`${message.time}-${index}`}
                      className={`flex flex-col ${isMe ? 'items-end' : 'items-start'}`}
                    >
                      <div
                        className={`max-w-[85%] rounded-lg px-4 py-3 text-sm leading-relaxed ${
                          isMe
                            ? 'bg-primary-600 text-background-50'
                            : 'bg-background-800 text-background-100'
                        } ${message.flag ? 'ring-1 ring-accent-500/70' : ''}`}
                      >
                        {message.text}
                        {message.flag && (
                          <span className="mt-2 flex items-center gap-1 text-[11px] text-accent-300">
                            <i className="ri-flag-2-line"></i>
                            关键信息
                          </span>
                        )}
                      </div>
                      <span className="mt-1.5 text-[11px] text-background-500">{message.time}</span>
                    </div>
                  );
                })}
              </div>

              <div className="mt-6 pt-5 border-t border-background-800 flex items-center gap-2 text-xs text-background-400">
                <i className="ri-shield-check-line"></i>
                截图已保留原始文件信息，可申请复核
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-5 flex flex-col gap-6">
            <Reveal delay={120}>
              <div className="w-full h-56 rounded-lg overflow-hidden border border-background-800">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20single%20smartphone%20glowing%20in%20a%20dark%20room%2C%20screen%20light%20illuminating%20scattered%20papers%20around%20it%2C%20moody%20low%20key%20photography%2C%20warm%20amber%20screen%20glow%2C%20investigative%20editorial%20atmosphere%2C%20dramatic%20contrast&width=800&height=1000&seq=nhbl-chat-01&orientation=portrait"
                  alt="私聊记录曝光 - 暗室中的手机屏幕与散落文件"
                  title="网红爆料 私聊记录截图整理"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </Reveal>

            <div className="flex flex-col gap-4">
              {chatHighlights.map((item, index) => (
                <Reveal key={item.name} delay={180 + index * 70}>
                  <div className="rounded-lg border border-background-800 bg-background-900 p-4 md:p-5 hover:border-background-700 transition-colors">
                    <div className="flex items-center justify-between gap-3">
                      <h3 className="text-sm font-medium text-background-50">{item.name}</h3>
                      <span className="text-[11px] text-background-500 whitespace-nowrap">
                        {item.time}
                      </span>
                    </div>
                    <p className="mt-2.5 text-xs leading-relaxed text-background-300">
                      {item.note}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ChatExpose;